// const baseURL = "http://localhost:8080";
const baseURL = process.env.REACT_APP_BASE_URL;

export const Endpoints = {
  GetLogin: () => `${baseURL}/admin/auth/login`,
  GetAdminProfile: () => `${baseURL}/admin/auth/profile`,

  GetTeam: () => `${baseURL}/admin/team`,
  GetAddTeamMemberProfile: () => `${baseURL}/admin/team/onboard`,
  GetDeleteTeamMemberProfile: (adminID: string) =>
    `${baseURL}/admin/member/${adminID}`,
  GetUpdateTeamMemberProfile: (adminID: string) =>
    `${baseURL}/admin/other/patch/${adminID}`,

  GetPlans: (page: number | string, limit: number | string) =>
    `${baseURL}/admin/plans?page=${page}&limit=${limit}`,
  GetSinglePlan: (planID: string) => `${baseURL}/admin/plan/${planID}`,
  GetCreateNewPlan: () => `${baseURL}/admin/plan/create`,
  GetUpdateExistingPlan: () => `${baseURL}/admin/plan/update`,

  GetTransactionsPaginated: (page: number, limit: number) =>
    `${baseURL}/admin/transactions?page=${page}&limit=${limit}`,
  GetOfflinePaymentsPaginated: (page: number, limit: number) =>
    `${baseURL}/admin/offline-payments?page=${page}&limit=${limit}`,
  GetUpdateOfflinePaymentStatus: (offlinePaymentID: string) =>
    `${baseURL}/admin/offline-payments/${offlinePaymentID}`,
  GetSingleTransaction: (transactionID: string) =>
    `${baseURL}/admin/transaction/${transactionID}`,
  GetSingleTransactionByReference: (reference: string) =>
    `${baseURL}/admin/transaction/reference/${reference}`,
  GetTransactionsByUserID: (userID: string) =>
    `${baseURL}/admin/user/transactions/${userID}`,

  GetUserProfiles: (page: number, limit: number) =>
    `${baseURL}/admin/users?page=${page}&limit=${limit}`,
  GetUserProfile: (userID: string) => `${baseURL}/admin/user/${userID}`,
  GetUsersByArray: () => `${baseURL}/admin/users/array`,
  GetSearchForUser: (search: string) =>
    `${baseURL}/admin/user/search/${search}`,
  GetSearchUsersByName: (name: string) => `${baseURL}/admin/user/name/${name}`,

  GetUsersSubscriptions: (page: number, limit: number) =>
    `${baseURL}/admin/subscriptions/get?page=${page}&limit=${limit}`,
  GetSingleSubscription: (subscriptionID: string) =>
    `${baseURL}/admin/subscription/${subscriptionID}`,

  GetSubscriptionsByUserID: (page: number, limit: number, userID: string) =>
    `${baseURL}/admin/subscriptions/user/${userID}?page=${page}&limit=${limit}`,

  GetUserTempsPaginated: (page: number, limit: number) =>
    `${baseURL}/admin/temps?page=${page}&limit=${limit}`,

  UpdateSpotifyInviteLink: (subscriptionID: string) =>
    `${baseURL}/admin/update-user-spotify/${subscriptionID}`,
  UpdateDuolingoInviteLink: (subscriptionID: string) =>
    `${baseURL}/admin/update-user-duolingo/${subscriptionID}`,
  GetAssignUserToPlan: (transactionID: string) =>
    `${baseURL}/admin/assign-to-sub/${transactionID}`,
  GetReassignUserToPlan: () => `${baseURL}/admin/subscription/reassign`,
  GetRemoveUserFromPlan: (subscriptionID: string) =>
    `${baseURL}/admin/user/expire/${subscriptionID}`,

  GetUsersTickets: (page: number, limit: number) =>
    `${baseURL}/admin/tickets?page=${page}&limit=${limit}`,
  GetUpdateTicketStatus: (ticketID: string) =>
    `${baseURL}/admin/ticket/${ticketID}`,
  GetTicketReplies: (ticketID: string) =>
    `${baseURL}/admin/ticket/replies/${ticketID}`,
  GetRespondToTicket: (ticketID: string) =>
    `${baseURL}/admin/ticket/reply/${ticketID}`,
  GetUploadFile: () => `${baseURL}/file/upload`,

  GetUsersRegistrationStats: () => `${baseURL}/stats/users/all`,
  GetUsersSubscriptionStats: () => `${baseURL}/stats/subscriptions`,
  GetUsersTransactionsStats: () => `${baseURL}/stats/transactions`,
  GetYoutubeTempForm: (tempID: string) => `${baseURL}/admin/form/${tempID}`,

  GetLoginAsUser: (userID: string) => `${baseURL}/admin/login-as/${userID}`,

  GetUpdatePromoterStatus: (promoterID: string) =>
    `${baseURL}/admin/promoter/status/${promoterID}`,
  GetConvertToPromoter: (userID: string) =>
    `${baseURL}/admin/promote/${userID}`,
  GetPromotersList: (page: number, limit: number) =>
    `${baseURL}/admin/promoters?page=${page}&limit=${limit}`,
  GetSinglePromoter: (userID: string) => `${baseURL}/admin/promoter/${userID}`,
  GetUpdatePromoterProfile: (promoterID: string) =>
    `${baseURL}/admin/promoter/${promoterID}`,
  GetMakePayout: (promoterID: string) =>
    `${baseURL}/admin/promoter/make-payout/${promoterID}`,

  GetSinglePromoterTransactions: (
    page: number,
    limit: number,
    userID: string
  ) =>
    `${baseURL}/admin/promoter/transactions/${userID}?page=${page}&limit=${limit}`,
  GetSinglePromoterPayoutHistory: (
    page: number,
    limit: number,
    userID: string
  ) =>
    `${baseURL}/admin/promoter/payouts/${userID}?page=${page}&limit=${limit}`,
  GetPromotersLeaderboard: (page: number, limit: number) =>
    `${baseURL}/admin/promoters/leaderboard?page=${page}&limit=${limit}`,
  GetDeleteOfflinePayment: (offlinePaymentID: string) =>
    `${baseURL}/admin/offline-payments/${offlinePaymentID}`,
  GetSubscribeOfflinePayment: (transactionID: string) =>
    `${baseURL}/admin/offline-subscription/${transactionID}`,
  GetSingleOfflinePayment: (offlinePaymentID: string) =>
    `${baseURL}/admin/offline/${offlinePaymentID}`,
};
